(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[797],{

/***/ 7317:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programmatic",
      function () {
        return __webpack_require__(287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AvatarProfile; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _library_utils_classNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5368);



const AvatarProfile = (param)=>{
    let { name , image , company , wide  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex min-w-0 flex-none items-center gap-16 truncate",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-28 w-28 shrink-0 rounded-full bg-cover bg-center md:h-40 md:w-40",
                title: name,
                style: {
                    backgroundImage: "url(".concat(image, ")")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_library_utils_classNames__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .A)("shrink truncate", wide ? "flex items-center gap-8 md:gap-12" : "flex flex-col gap-4 "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "truncate text-12-14 font-bold text-black dark:text-gray-300 md:text-14-16",
                        children: name
                    }),
                    wide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "h-4 w-4 rounded-full bg-gray-700"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "whitespace-normal text-12-14 text-gray-700 line-clamp-2 dark:text-gray-600 md:text-14-16",
                        children: company
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 7267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TitleAndMetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1576);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_data_siteMetadata__WEBPACK_IMPORTED_MODULE_4__);





function TitleAndMetaTags(props) {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const title = props.title || (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_4___default().title);
    const description = props.description || (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_4___default().description);
    const image = props.image || (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_4___default().socialBanner);
    const url =  false ? 0 : window.location.origin;
    const imageUrl = "".concat(url).concat(image);
    const path = props.pathname || router.pathname;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat(url).concat(path)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@humanloop"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            })
        ]
    });
}


/***/ }),

/***/ 3165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ CodeShowcase; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_library_utils_classNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5368);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



const CodeShowcase = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "inline-block rounded border border-gray-800 bg-[#262626] px-12 py-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,components_library_utils_classNames__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .A)("flex gap-16 font-mono tracking-wide text-white", size === 14 && "text-14-20", size === 18 && "text-18-24", size === 24 && "text-24-32"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: ">"
                }),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-blue-400",
                    children: "humanloop"
                }),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "init"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-cyan-600",
                    children: "myproject"
                }),
                size === 24 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CursorPrompt, {
                    height: 30,
                    width: 14
                }),
                size === 18 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CursorPrompt, {
                    height: 24,
                    width: 12
                }),
                size === 14 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CursorPrompt, {
                    height: 22,
                    width: 8
                })
            ]
        })
    });
};
const CursorPrompt = (param)=>{
    let { width , height  } = param;
    //  Cursor prompt rectangle
    /* Blinks 10 times */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "-ml-8 inline-block animate-[blink_1s_steps(1,end)_10] text-gray-800",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            width: width,
            height: height,
            fill: "currentColor"
        })
    });
};


/***/ }),

/***/ 7921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useBreakpoints; }
/* harmony export */ });
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5339);

// Media breakpoints with same widths as Tailwind CSS
const useBreakpoints = ()=>{
    const { width , height  } = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_0__/* .useWindowSize */ .iP)();
    const isLessThanSmallWidth = width < 640;
    const isSmallWidth = width >= 640;
    const isMediumWidth = width >= 768;
    const isLargeWidth = width >= 1024;
    return {
        width,
        isLessThanSmallWidth,
        isSmallWidth,
        isMediumWidth,
        isLargeWidth
    };
};


/***/ }),

/***/ 287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProgrammaticHome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(3519);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/programmatic/BetterDataSection.tsx



const BetterDataSection = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container-lg grid-12 pt-[108px] pb-80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-full md:col-span-5 md:col-start-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "items-center font-display text-24-32 md:text-32-40",
                            children: [
                                "Better data",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                                    className: "ml-4 mr-8 mb-4 inline-block h-24 w-24 flex-none"
                                }),
                                "Better models"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-40 flex flex-col gap-20 md:max-w-[336px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-16-24 md:text-18-28 ",
                                    children: "A big weakly supervised dataset can be better than a small labelled dataset. Humanloop Programmatic dramatically increases the size of your datasets."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-16-24 text-gray-700",
                                    children: "Benefit from both your unlabelled and manually annotated data. The combination of programmatic labels with manual labels leads to a better model."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-full mx-auto max-w-[480px] px-20 pt-40 md:col-span-6 md:pt-0 md:pl-40 md:pr-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/assets/marketing/Dataset Stacks.png",
                    className: "",
                    alt: "More data, better models"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/GlobeAltIcon.js
var GlobeAltIcon = __webpack_require__(1090);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ScaleIcon.js
var ScaleIcon = __webpack_require__(8834);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/LightningBoltIcon.js
var LightningBoltIcon = __webpack_require__(4320);
;// CONCATENATED MODULE: ./components/programmatic/FeaturesSection.tsx


const features = [
    {
        name: "Span Extraction",
        description: "Rapidly annotate for NER or token classification.",
        Icon: GlobeAltIcon/* default */.Z,
        img: "/assets/marketing/icons/paragraph-normal.png"
    },
    {
        name: "Classification",
        description: "Rule-based document classification made easy.",
        Icon: ScaleIcon/* default */.Z,
        img: "/assets/marketing/icons/tags.png"
    },
    {
        name: "Data Explorer",
        description: "Easily explore large datasets or zoom into specific documents.",
        Icon: LightningBoltIcon/* default */.Z,
        img: "/assets/marketing/icons/binocular.png"
    },
    {
        name: "Instant Feedback",
        description: "Immediately see the impact of your ideas across your dataset.",
        Icon: LightningBoltIcon/* default */.Z,
        img: "/assets/marketing/icons/pulse.png"
    },
    {
        name: "No-code Rule Builders",
        description: "Apply powerful labeling functions with intuitive UI.",
        Icon: LightningBoltIcon/* default */.Z,
        img: "/assets/marketing/icons/office-file-glue.png",
        comingSoon: true
    },
    {
        name: "Export",
        description: "Export your functions and labelled data in popular formats.",
        Icon: LightningBoltIcon/* default */.Z,
        img: "/assets/marketing/icons/upload-thick-box.png"
    }
];
const FeaturesSection = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container-lg grid-12 bg-white py-48",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
            className: "col-span-full grid gap-32 sm:col-span-10 sm:col-start-2 sm:-mr-40 sm:grid-cols-2 sm:gap-40 lg:grid-cols-3 lg:gap-80",
            children: features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-start gap-24 md:flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: feature.img,
                            alt: feature.name,
                            className: "mt-4 h-28 w-28 md:h-40 md:w-40"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                    className: "flex flex-wrap items-center gap-x-8 gap-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-16-24 font-bold text-gray-900",
                                            children: feature.name
                                        }),
                                        feature.comingSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-min rounded bg-yellow-200 px-4 py-2 text-11-14",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "whitespace-nowrap text-11-14 font-bold text-yellow-800",
                                                children: "Coming soon"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-8 mr-20 text-16-24 text-gray-700",
                                    children: feature.description
                                })
                            ]
                        })
                    ]
                }, feature.name))
        })
    });
};

// EXTERNAL MODULE: ./components/AvatarProfile.tsx
var AvatarProfile = __webpack_require__(4351);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MailIcon.js
var MailIcon = __webpack_require__(9700);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
// EXTERNAL MODULE: ./services/analytics.service.ts
var analytics_service = __webpack_require__(2554);
// EXTERNAL MODULE: ./services/api.service.ts + 1 modules
var api_service = __webpack_require__(1506);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(8680);
// EXTERNAL MODULE: ./components/library/Button.tsx + 1 modules
var Button = __webpack_require__(1317);
// EXTERNAL MODULE: ./components/library/Icons.tsx
var Icons = __webpack_require__(4305);
// EXTERNAL MODULE: ./components/library/utils/classNames.ts
var classNames = __webpack_require__(5368);
;// CONCATENATED MODULE: ./components/programmatic/EmailForm.tsx











const BUTTON_TEXT = "Get started";
const EmailForm = (param)=>{
    let { shade  } = param;
    const [loading, setLoading] = (0,react.useState)(false);
    const [form, setForm] = (0,react.useState)({
        email: ""
    });
    const router = (0,next_router.useRouter)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        analytics_service/* Analytics.identify */.cp.identify(form.email, {
            email: form.email
        });
        analytics_service/* Analytics.track */.cp.track(analytics_service/* EventObject.Form */.fC.Form, analytics_service/* EventAction.Submitted */.AO.Submitted, {
            form: "programmatic-interested",
            email: form.email
        });
        const result = await api_service/* ApiService.post */.s.post("/api/programmatic-interested", form, {}, (e, method, url, data, config)=>{
            var ref, ref1;
            const message = e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
            console.log("Failed to fetch:", e, method, url, data, config);
            if (message) {
                react_hot_toast_esm/* default.error */.ZP.error(message);
            }
            setLoading(false);
        });
        if (result.status === 200) {
            setTimeout(()=>{
                router.push(constants/* PROGRAMMATIC_TYPEFORM */.pI);
            }, 500);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex justify-center gap-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative grow rounded",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MailIcon/* default */.Z, {
                                className: "h-24 w-24 text-gray-400",
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "email",
                            name: "email",
                            id: "email",
                            required: true,
                            className: "form-input block h-[44px] w-full rounded border-[#757DF0] pl-48 pr-[140px] text-14-20 text-black ring-[3px] ring-blue-200 md:h-52 md:pr-0 md:text-16-24",
                            placeholder: "your email",
                            value: form.email,
                            onChange: (e)=>{
                                setForm({
                                    ...form,
                                    email: e.target.value
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute inset-y-0 right-0 p-6 md:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "submit",
                                styling: "solid",
                                shade: Button/* ButtonShade.Blue */.B.Blue,
                                className: (0,classNames/* classNames */.A)(shade === "black" && "!bg-black"),
                                size: 32,
                                loading: loading,
                                IconRight: loading ? Icons/* LoadingIcon */.Ho : undefined,
                                children: BUTTON_TEXT
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "submit",
                    styling: "solid",
                    shade: Button/* ButtonShade.Blue */.B.Blue,
                    className: (0,classNames/* classNames */.A)(shade === "black" && "!bg-black", "hidden md:flex ", loading ? "pl-32" : "px-32"),
                    loading: loading,
                    IconRight: loading ? Icons/* LoadingIcon */.Ho : undefined,
                    size: 52,
                    children: BUTTON_TEXT
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/library/Logos.tsx
var Logos = __webpack_require__(6786);
;// CONCATENATED MODULE: ./components/programmatic/Footer.tsx




const Footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mt-[64px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pointer-events-none absolute inset-0 flex flex-col",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-140 flex-none"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right-0 top-0 bottom-0 -z-10 h-full w-full min-w-[2500] bg-blue-800 bg-bottom bg-no-repeat ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "right-0 top-0 bottom-0 -z-10 h-full w-full min-w-[2500] bg-blue-800 bg-bottom bg-no-repeat opacity-40 ",
                            style: {
                                backgroundImage: 'url("/assets/tag-silhouette.png")'
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " rounded-[4px] border border-gray-400 bg-white py-32 px-24 sm:p-80",
                    style: {
                        boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.03), 0px 5px 8px rgba(0, 0, 0, 0.03)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid gap-x-60 text-18-28 text-gray-700 lg:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "mb-32 font-display text-24-32 text-black md:text-32-40",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "rounded bg-blue-200 px-4 text-blue-500",
                                                children: "Free"
                                            }),
                                            ", ",
                                            "customisable and extensible by design"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mt-24 text-16-24 md:text-18-28",
                                        children: [
                                            "As data scientists and engineers ourselves, we know that you need flexibility and control. So we’ve designed Programmatic to be ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold",
                                                children: "easily extensible"
                                            }),
                                            " and to play nicely with the your",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold",
                                                children: "existing workflows"
                                            }),
                                            " and data science tools."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-24 text-16-24 md:text-18-28",
                                        children: "You can export your data in formats compatible with all major NLP libraries, write custom metrics, and have full control over tokenization and pre-processing."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mt-24 text-16-24 md:text-18-28 lg:pt-80 ",
                                        children: [
                                            "We’ve also chosen to make Programmatic",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold",
                                                children: "free"
                                            }),
                                            " so nothing stops individual data scientists from getting the benefit of this powerful tool."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mt-24 text-16-24 md:text-18-28",
                                        children: [
                                            "The",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: "https://humanloop.com",
                                                className: "text-blue-600 no-underline hover:underline",
                                                children: "Humanloop Platform"
                                            }),
                                            " ",
                                            "closes the loop on training your NLP models. You can annotate ground truths, improve your models, and",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold",
                                                children: "instantly deploy custom NLP"
                                            }),
                                            ". We believe it is the next best step for your dataset and we hope this inspires you to use it."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-24",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarProfile/* AvatarProfile */.h, {
                                            name: "Raza Habib",
                                            image: "/assets/marketing/people/raza.jpg",
                                            company: "CEO Humanloop"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container-lg mt-140 flex flex-col gap-12 text-center text-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-24-32 opacity-70 md:text-32-32",
                        children: "Bigger, cleaner datasets await"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-40 text-24-32 text-white md:text-32-32",
                        children: "Get started now"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto mb-[92px] flex max-w-md justify-center gap-12 md:max-w-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailForm, {
                            shade: "black"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center gap-16 border-t border-blue-100/20 bg-blue-800 py-32 text-center text-white",
                children: [
                    "Powered by",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://humanloop.com",
                        title: "Humanloop - all in one platform for NLP",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* HumanloopLogo */.k, {
                            className: "h-24 w-[106px]"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(7921);
;// CONCATENATED MODULE: ./components/programmatic/Header.tsx






const Header = ()=>{
    const { isMediumWidth  } = (0,useBreakpoints/* useBreakpoints */.k)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto mb-[112px] flex w-full max-w-7xl items-center justify-between pt-24 pl-16 pr-8 md:py-40 md:px-40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: constants/* HOMEPAGE_LINK */.fm,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* HumanloopLogo */.k, {
                    className: "h-28 text-gray-800 hover:text-gray-900"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        href: constants/* PROGRAMMATIC_DOCS_LINK */.Hh,
                        size: isMediumWidth ? 32 : 24,
                        children: "Documentation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        href: constants/* TWITTER_LINK */.v,
                        IconLeft: Icons/* TwitterIcon */.Zm,
                        styling: "ghost",
                        size: isMediumWidth ? 32 : 24,
                        shade: Button/* ButtonShade.Gray */.B.Gray,
                        children: "Twitter"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/programmatic/ProgrammaticHero.tsx




const ProgrammaticHero = ()=>{
    const { isMediumWidth  } = (0,useBreakpoints/* useBreakpoints */.k)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container-lg grid-12 mx-auto text-center selection:rounded selection:border selection:bg-blue-200",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-span-full text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* ProgrammaticLogo */.Q, {
                    className: "mx-auto h-[22px] md:h-28"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: "mt-40 font-display text-[40px] leading-[48px] md:text-[64px] md:leading-[88px]",
                    children: [
                        "Powerful",
                        " ",
                        isMediumWidth ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "rounded-lg bg-blue-200 py-6 px-4",
                            children: "Weak Labeling"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "rounded-lg bg-blue-200 py-0 px-4 ",
                                    children: "Weak"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "rounded-lg bg-blue-200 py-0 px-4",
                                    children: "Labeling"
                                })
                            ]
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "mx-auto mt-24 mb-40 max-w-sm text-14-20 leading-[22px] text-gray-700 md:max-w-md md:text-20-32 ",
                    children: [
                        "Create large",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-gray-900",
                            children: "high-quality datasets"
                        }),
                        " for NLP in minutes. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-gray-900",
                            children: "No hand labeling"
                        }),
                        " ",
                        "required."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mb-[92px] max-w-md md:max-w-lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailForm, {})
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/plyr-react/dist/src/index.es.js + 2 modules
var index_es = __webpack_require__(8955);
// EXTERNAL MODULE: ./node_modules/plyr-react/dist/plyr.css
var plyr = __webpack_require__(46);
// EXTERNAL MODULE: ./node_modules/posthog-js/dist/es.js
var es = __webpack_require__(9893);
// EXTERNAL MODULE: ./components/programmatic/VideoPlayer.module.css
var VideoPlayer_module = __webpack_require__(3005);
var VideoPlayer_module_default = /*#__PURE__*/__webpack_require__.n(VideoPlayer_module);
;// CONCATENATED MODULE: ./components/programmatic/VideoPlayer.tsx








const ProgrammaticVideoComponent = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
        source: {
            type: "video",
            sources: [
                {
                    src: "686272874",
                    provider: "vimeo"
                }
            ],
            poster: "/assets/product/spantagging.png"
        },
        options: {
            ratio: "1730:1080",
            speed: {
                selected: 1.25,
                options: [
                    0.5,
                    0.75,
                    1,
                    1.25,
                    1.5,
                    1.75,
                    2
                ]
            }
        }
    });
};
const ProgrammaticVideo = /*#__PURE__*/ (0,react.memo)(ProgrammaticVideoComponent);
// Memo to avoid re-rendering component as Plyr does not seem to like that (and will disappear)
const VideoPlayer = ()=>{
    const [hideOverlay, setHideOverlay] = (0,react.useState)(false);
    const handlePlayClick = ()=>{
        es/* default.capture */.Z.capture("".concat(analytics_service/* EventObject.Video */.fC.Video, " ").concat(analytics_service/* EventAction.Played */.AO.Played), {
            property: "humanloop"
        });
        setHideOverlay(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classNames/* classNames */.A)((VideoPlayer_module_default()).player, "group -m-1 cursor-pointer"),
        onClick: handlePlayClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgrammaticVideo, {}),
            !hideOverlay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pointer-events-none absolute inset-0 flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute z-[51] ml-60 mt-60 h-32 w-32 shrink-0 rounded-full border-2 border-white bg-cover bg-center opacity-0 duration-150 group-hover:opacity-100",
                        title: "Raza Habib",
                        style: {
                            backgroundImage: "url(/assets/marketing/people/raza.jpg)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "z-[1] mt-[105px] rounded-full bg-white px-12 py-8 opacity-0 shadow-c duration-150 group-hover:opacity-100",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-12-14 font-bold text-gray-900",
                            children: "Learn how to get hundreds of annotations in minutes."
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var programmatic_VideoPlayer = (VideoPlayer);

// EXTERNAL MODULE: ./components/programmatic/CodeShowcase.tsx
var CodeShowcase = __webpack_require__(3165);
;// CONCATENATED MODULE: ./components/programmatic/ProcessStepsSection.tsx



const StepNumber = (param)=>{
    let { number  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex h-32 w-32 items-center justify-center rounded-full border-[3px] border-[#B8F9B8] border-opacity-25 text-green-300",
        children: number
    });
};
const steps = [
    {
        title: "Get Programmatic",
        description: "Download Programmatic and install it on your local machine. Spin up a new project in seconds.  \uD83D\uDE80"
    },
    {
        title: "Write labeling functions",
        description: "Easily create sets of approximate functions and smart rules that run through your data quickly adding labels. Wave goodbye to painstaking manual highlighting. \uD83D\uDC4B"
    },
    {
        title: "Export large clean datasets",
        description: "Programmatic then intelligently combines the noisy labels produced by your functions into a large clean dataset that you can start training models on immediately. ✨"
    }
];
const ProcessStepsSection = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid-12 mx-auto mb-28 md:mb-140 ",
        children: steps.map((step, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classNames/* classNames */.A)("col-span-full min-h-[140] justify-between border-t border-gray-800/50 md:col-span-10 md:col-start-2 md:grid-cols-10 "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid-10 col-span-full my-32 items-start gap-y-16 md:col-span-9 md:gap-y-24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-full flex items-center gap-20 md:col-span-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepNumber, {
                                    number: index + 1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: step.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "col-span-full text-left md:col-span-5 md:col-start-5 ",
                            children: step.description
                        })
                    ]
                })
            }, index))
    });
};

;// CONCATENATED MODULE: ./components/programmatic/OverviewSection.tsx






const OverviewSection = ()=>{
    const { isMediumWidth , width  } = (0,useBreakpoints/* useBreakpoints */.k)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pointer-events-none absolute inset-0 flex flex-col",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-140 flex-none"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-z-10 w-full flex-1 bg-black"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-lg grid-gap grid grid-cols-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative col-span-full overflow-hidden rounded-lg md:col-span-8 md:col-start-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(programmatic_VideoPlayer, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-lg ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-full mt-40 flex flex-col gap-32 text-center text-white md:mt-80 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto max-w-2xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-18-28 opacity-70 md:text-32-40",
                                    children: "No more waiting for manual annotation"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-18-28 text-white md:text-32-40",
                                    children: "Get started with programmatic labeling"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto max-w-md text-14-20 text-gray-400 md:text-18-28 ",
                            children: "Humanloop Programmatic is a new kind of annotation tool that combines advances in weak supervision with data-centric UI to get you annotated data, fast."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-full mb-40",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeShowcase/* CodeShowcase */.V, {
                                size: isMediumWidth ? 24 : 18
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessStepsSection, {})
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/programmatic/PrivacySection.tsx



const PrivacySection = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container-lg relative my-16 md:my-160",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:grid md:grid-flow-row-dense md:grid-cols-2 md:items-center md:gap-32",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative -mx-4 mt-10 md:mt-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "relative mx-auto",
                        width: 544,
                        src: "/assets/product/product-and-terminal.png",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sm:ml-40 md:ml-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "font-display text-32-40",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-gray-600",
                                    children: [
                                        "It’s your data —",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-gray-900",
                                    children: "Keep it secret, keep it safe"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "my-32 text-16-24 text-gray-600 md:max-w-xs",
                            children: [
                                "Get back control of your data. Humanloop Programmatic runs locally on your machine and no private data ever leaves.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Since the data is labelled programmatically, you can even label data that no human ever needs to see."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-16 rounded bg-gray-200 p-16 text-gray-700",
                            children: "Working with EHR data is incredibly sensitive so we love that Programmatic doesn't send our data to the cloud."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarProfile/* AvatarProfile */.h, {
                            name: "Dr Bram Von Es",
                            company: "MedX AI",
                            image: "/assets/customers/bram2.jpeg"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/programmatic/TagSilhouetteBackground.tsx




const TagSilhouetteBackground = (param)=>{
    let { children  } = param;
    const { isMediumWidth , isLargeWidth  } = (0,useBreakpoints/* useBreakpoints */.k)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 bottom-0 left-0 right-0 -z-10 overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,classNames/* classNames */.A)("absolute right-0 bottom-0 h-full w-full min-w-[2500] bg-center  bg-no-repeat", isMediumWidth ? "top-4" : "top-80 bg-cover"),
                    style: {
                        backgroundImage: isMediumWidth ? 'url("/assets/tag-silhouette.png")' : 'url("/assets/tag-silhouette-mobile.png")'
                    }
                })
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./components/programmatic/TestimonialsSection.tsx





const testimonials = [
    // {
    //   name: "Marc Falk",
    //   company: "CTO at REIQ",
    //   image: "/assets/customers/marc-reiq.jpeg",
    //   quote:
    //     "Download Programmatic and install it on your local machine via the command line. Spin up a new project and follow the testimonials to import your data.",
    // },
    // {
    //   name: "Victor Urano Braga",
    //   company: "CSO at Pluggy (YC S21)",
    //   image: "/assets/customers/victor-pluggy.jpeg",
    //   // TODO: made up. Get a genuine quote!
    //   quote:
    //     "Programmatic is a so useful for us to label thousands of transations a day. We couldn't do without it.",
    // },
    {
        name: "Henry Maguire",
        company: "DS at Orbital Witness",
        image: "/assets/customers/henry_maguire.jpeg",
        href: "https://twitter.com/hejmaguire/status/1500960472195125252?s=20&t=d-ZQ6OQCJEY8TcIQxbtCPA",
        quote: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Programmatic is phenemonal! I think it's hard to justify NOT using this as a jumping off point for most NLP projects."
        })
    },
    {
        name: "Jonathan Bourne",
        company: "PhD Researcher at UCL",
        image: "/assets/customers/jonathan-bourne.jpeg",
        href: "https://twitter.com/sse_data/status/1499802971458215947",
        quote: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Programmatic does't just make projects easier. It makes projects that were impossible straightforward and easy to understand. Pure \uD83D\uDD25\uD83D\uDD25\uD83D\uDD25"
        })
    },
    {
        name: "Paul Simmering",
        company: "Data Scientist at Q",
        image: "/assets/customers/paul-simmering.jpeg",
        href: "https://twitter.com/paul_simmering/status/1499737687053549576",
        quote: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Thank you",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "text-blue-600 no-underline hover:underline",
                    target: "_blank",
                    rel: "noreferrer",
                    href: "https://twitter.com/humanloop",
                    onClick: (event)=>{
                        event.stopPropagation();
                    },
                    children: "@humanloop"
                }),
                " ",
                "for letting me test Programmatic! It's cool to see a glimpse of next generation labeling for NLP."
            ]
        })
    },
    {
        name: "Bram van Es",
        company: "Researcher at UMCU",
        image: "/assets/customers/bram.jpeg",
        href: "https://twitter.com/bramiozo/status/1500836959429840896?s=20&t=d-ZQ6OQCJEY8TcIQxbtCPA",
        quote: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Human in the loop is the future of machine learning. "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Using #programmatic from",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-blue-600 no-underline hover:underline",
                            target: "_blank",
                            rel: "noreferrer",
                            href: "https://twitter.com/humanloop",
                            onClick: (event)=>{
                                event.stopPropagation();
                            },
                            children: "@humanloop"
                        }),
                        " ",
                        "now!"
                    ]
                })
            ]
        })
    },
    {
        name: "Craig Pfeifer",
        company: "ML Engineer, ex-Mitre",
        image: "/assets/customers/craig-pfeifer.jpeg",
        href: "https://www.linkedin.com/feed/update/urn:li:activity:6945117473994137600",
        quote: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "I've been using Programmatic for a month and it is the easiest, fastest way to annotate text. It is even appropriate for sensitive text as it runs 100% local."
            })
        })
    },
    {
        name: "Federico Miras",
        company: "CEO at Pluggy (YC S21)",
        image: "/assets/customers/federico-pluggy.jpg",
        href: "https://twitter.com/fefomiras/status/1509529837605515264",
        quote: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Programmatic",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-blue-600 no-underline hover:underline",
                            target: "_blank",
                            rel: "noreferrer",
                            href: "https://twitter.com/humanloop",
                            onClick: (event)=>{
                                event.stopPropagation();
                            },
                            children: "@humanloop"
                        }),
                        " ",
                        "is the way to go for NLP projects."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "This is literally how I imagined humans working with AI, actively interacting with data and having instant feedback"
                })
            ]
        })
    },
    {
        name: "Sam Hardy",
        company: "Deep Learning at Eliiza",
        image: "/assets/customers/samhardy.jpeg",
        href: "https://twitter.com/samhardyhey/status/1523987954527793152",
        quote: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Have recently been tyre-kicking Programmatic by",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-blue-600 no-underline hover:underline",
                            target: "_blank",
                            rel: "noreferrer",
                            href: "https://twitter.com/humanloop",
                            onClick: (event)=>{
                                event.stopPropagation();
                            },
                            children: "@humanloop"
                        }),
                        " ",
                        "; an annotation tool that significantly improves cold-start NLP (classification/NER) projects."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Programmatic is the way to go for NLP projects."
                })
            ]
        })
    },
    {
        name: "Had Seddiqi",
        company: "Director of ML at Ontra",
        image: "/assets/customers/had-seddiqi.jpeg",
        href: "https://twitter.com/HoddieOt/status/1522732405655687168",
        quote: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "been messing around with a programmatic labeling tool by",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-blue-600 no-underline hover:underline",
                            target: "_blank",
                            rel: "noreferrer",
                            href: "https://twitter.com/humanloop",
                            onClick: (event)=>{
                                event.stopPropagation();
                            },
                            children: "@humanloop"
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "... its the pinnacle of tools when they can educate us to work and be smarter"
                })
            ]
        })
    }
];
const TestimonialCard = (param)=>{
    let { name , company , href , image , quote  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: ()=>{
            window.open(href, "_blank");
        },
        className: (0,classNames/* classNames */.A)("cursor-pointer", "flex w-full max-w-full flex-col justify-between gap-24 rounded border border-gray-300 p-24", href ? "hover:border-gray-400 hover:bg-gray-100" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "prose max-w-prose text-16-24 text-gray-800",
                children: quote
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2 flex items-center justify-between gap-x-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarProfile/* AvatarProfile */.h, {
                        name: name,
                        image: image,
                        company: company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* TwitterIcon */.Zm, {
                            color: "#009ef7"
                        })
                    })
                ]
            })
        ]
    });
};
const TestimonialsSection = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container-lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "mb-40 text-center font-display text-32-40 ",
                children: "What others say"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:grid-3 grid-1 md:justify-items-none mb-140 justify-items-center gap-24",
                children: testimonials.map((testimonial)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCard, {
                        ...testimonial
                    }, testimonial.name))
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/TitleAndMetaTags.tsx
var TitleAndMetaTags = __webpack_require__(7267);
;// CONCATENATED MODULE: ./pages/programmatic.tsx











function ProgrammaticHome() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleAndMetaTags/* TitleAndMetaTags */.H, {
                title: "Humanloop Programmatic – Powerful weak labelling",
                description: "An annotation tool to create large high-quality datasets for NLP in minutes. No hand labelling required.",
                image: "Social share programmatic gradient.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagSilhouetteBackground, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgrammaticHero, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BetterDataSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacySection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 2554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ EventAction; },
/* harmony export */   "cp": function() { return /* binding */ Analytics; },
/* harmony export */   "fC": function() { return /* binding */ EventObject; }
/* harmony export */ });
/* unused harmony export identify */
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9893);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_1__);
// https://www.typescriptlang.org/docs/handbook/triple-slash-directives.html is a thing
/// <reference types="@types/segment-analytics" />


var EventObject;
(function(EventObject) {
    EventObject[// Preferably use the semantic group if available and fallback
    // to the literal objects (e.g. Button) if that has its challenges.
    "Button"] = "Button";
    EventObject["Page"] = "Page";
    EventObject["Form"] = "Form";
    EventObject["Video"] = "Video";
    EventObject[// Programmatic App
    "AggregateResults"] = "Aggregate Results";
    EventObject["CodeEditor"] = "Code Editor";
    EventObject["Debug"] = "Debug";
    EventObject["Datapoint"] = "DataPoint";
    EventObject["Filter"] = "Filter";
    EventObject["Function"] = "Function";
    EventObject["GroundTruth"] = "Ground Truth";
    EventObject["Pane"] = "Pane";
    EventObject["SpanPopover"] = "Span Popover";
    EventObject["Template"] = "Template";
    EventObject["Project"] = "Project";
})(EventObject || (EventObject = {}));
var EventAction;
(function(EventAction) {
    EventAction["Changed"] = "changed";
    EventAction["Clicked"] = "clicked";
    EventAction["Created"] = "created";
    EventAction["Disabled"] = "disabled";
    EventAction["Enabled"] = "enabled";
    EventAction["Exported"] = "exported";
    EventAction["Played"] = "played";
    EventAction["Resized"] = "resized";
    EventAction["Run"] = "run";
    EventAction["Saved"] = "saved";
    EventAction["Scrolled"] = "scrolled";
    EventAction["Searched"] = "searched";
    EventAction["Selected"] = "selected";
    EventAction["Sorted"] = "sorted";
    EventAction["Submitted"] = "submitted";
    EventAction["Viewed"] = "viewed";
})(EventAction || (EventAction = {}));
const APPLICATION_CONTEXT = "website";
const identify = (userId, traits)=>{
    var ref;
    window === null || window === void 0 ? void 0 : (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.identify(userId, {
        application_context: APPLICATION_CONTEXT,
        ...traits
    });
    // PostHog
    posthog_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].identify */ .Z.identify(userId, {
        application_context: APPLICATION_CONTEXT,
        ...traits
    });
};
const page = (// Page call will include other helpful properties automatically like url, title, referrer.
category, name, properties)=>{
    var ref;
    window === null || window === void 0 ? void 0 : (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.page(category, name, {
        application_context: APPLICATION_CONTEXT,
        ...properties
    });
    // <PostHog /> component should do this automatically.
    // Sending a capture event anyw
    posthog_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].capture */ .Z.capture("".concat(EventObject.Page, " ").concat(EventAction.Viewed), {
        ...properties,
        category,
        name
    });
};
const track = (eventObject, action, properties)=>{
    var ref;
    window === null || window === void 0 ? void 0 : (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.track("".concat(eventObject, " ").concat(action), {
        action,
        application_context: APPLICATION_CONTEXT,
        ...properties
    });
    // PostHog
    posthog_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].capture */ .Z.capture("".concat(eventObject, " ").concat(action), properties);
    // TODO: Fire GA event here. GA events need to be named differently however.
    // // GA
    // window.gtag("event", `${eventObject} ${action}`, properties);
    const noTagsAffected = react_gtm_module__WEBPACK_IMPORTED_MODULE_1___default().dataLayer({
        dataLayer: {
            event: "website_analytics",
            trackedEvent: "".concat(eventObject, " ").concat(action),
            ...properties
        }
    });
};
const reset = ()=>{
    var ref;
    window === null || window === void 0 ? void 0 : (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.reset();
};
const Analytics = {
    identify,
    page,
    track,
    reset
};


/***/ }),

/***/ 1506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ ApiService; }
});

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
;// CONCATENATED MODULE: ./components/ToastErrorHandler.tsx


const ErrorToast = (param)=>{
    let { message , method , url  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            message,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-11-14 text-gray-700",
                children: [
                    method,
                    " on ",
                    url
                ]
            })
        ]
    });
};
const toastErrorHandler = (e, method, url, data, config)=>{
    console.log("Failed to fetch:", e, method, url, data, config);
    if (e.message) {
        react_hot_toast_esm/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorToast, {
            message: e.message,
            method: method,
            url: url
        }), {
            duration: 8000
        });
    }
};

;// CONCATENATED MODULE: ./services/api.service.ts
/**
 * This module contains centralized definitions for making API requests from the
 * frontend.
 *
 */ 

const request = async function(method, url) {
    let data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, onError = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : toastErrorHandler;
    const instance = axios_default().create({});
    try {
        return await instance({
            method,
            url,
            data,
            ...config
        });
    } catch (e) {
        onError(e, method, url, data, config);
        throw e;
    }
};
const get = function(url) {
    let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, onError = arguments.length > 2 ? arguments[2] : void 0;
    return request("GET", url, {}, config, onError);
};
const post = function(url, data) {
    let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, onError = arguments.length > 3 ? arguments[3] : void 0;
    return request("POST", url, data, config, onError);
};
const put = function(url, data) {
    let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, onError = arguments.length > 3 ? arguments[3] : void 0;
    return request("PUT", url, data, config, onError);
};
const patch = function(url, data) {
    let config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, onError = arguments.length > 3 ? arguments[3] : void 0;
    return request("PATCH", url, data, config, onError);
};
const remove = function(url) {
    let config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, onError = arguments.length > 2 ? arguments[2] : void 0;
    return request("DELETE", url, {}, config, onError);
};
// SWR shim which resolves the response data
// for the caller
const getJSON = async (url)=>{
    const response = await get(url);
    return response.data;
};
const ApiService = {
    get,
    post,
    put,
    patch,
    remove,
    getJSON
};


/***/ }),

/***/ 3005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"player":"VideoPlayer_player__LAkiM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,764,669,530,826,417,774,888,179], function() { return __webpack_exec__(7317); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);